export class Cart {
  constructor() {
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.getCart = this.getCart.bind(this);
    this.updateCounter = this.updateCounter.bind(this);
    this.add = this.add.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.build = this.build.bind(this);
    this.buildCartPage = this.buildCartPage.bind(this);
    this.buildVariantOptions = this.buildVariantOptions.bind(this);
    this.buildVariantProperties = this.buildVariantProperties.bind(this);
    this.optimizeImageUrl = this.optimizeImageUrl.bind(this);
    this.selectors = {
      body: 'body',
      cartDrawer: '#cart-drawer',
      cartHolder: '.js-cart-holder',
      cartOpenElement: '.js-drawer-cart-open',
      cartCloseElement: '.js-drawer-cart-close',
    };
    this.classes = {
      cartCount: '.js-cart-count',
      hidden: 'is-hidden',
      bodyClass: 'is-drawer-open no-scroll',
      empty: 'is-empty',
      visible: 'is-visible',
      btnLoading: 'btn--loading',
    };
    this.isCartBuilded = false;

    $(document).on(
      'click',
      this.selectors.cartOpenElement,
      $.proxy(function(event) {
        event.preventDefault();

        this.open();
      }, this)
    );

    $(document).on(
      'click',
      this.selectors.cartCloseElement,
      $.proxy(function(event) {
        event.preventDefault();

        this.close();
      }, this)
    );
  }

  /**
   * Get the cart and build it
   * @return {void}
   */

  getCart() {
    $.ajax({
      url: '/cart?view=json',
      context: this,
      type: 'GET',
      dataType: 'json',
      success(res) {
        this.build(res);
      },
      error(err) {
        alert(err.responseJSON.description);
      },
    });
  }

  /**
   * Add item(s) to the cart and build it
   * @param {Array} items An array holding the object(s) with item properties. Example: [{ 33501660184709, 1 }, { 33501234593925, 3 }]
   * @return {void}
   */

  add(items) {
    $.ajax({
      url: '/cart/add.js',
      context: this,
      type: 'POST',
      dataType: 'json',
      data: { items },
      success(res) {
        this.getCart();
        $('.js-ajax-add').removeClass(this.classes.btnLoading);
      },
      error(err) {
        alert(err.responseJSON.description);
        $('.js-ajax-add').removeClass(this.classes.btnLoading);
      },
    });
  }

  /**
   * Update/Remove item from the cart
   * @param  {Integer} quantity         Quantity of the updated item. 0 for item removal.
   * @param  {Integer} id               The key of the line item.
   * @param  {Object}  properties       Properties of the line item.
   * @return {void}
   */

  updateItem(quantity, id, properties = {}, isCartPage = false) {
    $.ajax({
      url: '/cart/change.js',
      context: this,
      type: 'POST',
      dataType: 'json',
      data: { quantity, id, properties },
      success(res) {
        this.build(res, isCartPage);
      },
      error(err) {
        alert(err.responseJSON.description);
      },
    });
  }

  /**
   * Build item variants, if available
   * @param  {Object} item The item
   * @return {String}      The variants HTML, if variants available, otherwise - ''
   */

  buildVariantOptions(item) {
    const hasVariants = item.options_with_values.length && item.options_with_values[0].value != 'Default Title';
    let variantsHtml = '';

    if (hasVariants) {
      item.options_with_values.forEach((option) => {
        let template = Shopify.theme.templates.line_item_variants;
        template = template.replace(/{{optionName}}/g, option.name);
        template = template.replace(/{{optionValue}}/g, option.value);

        variantsHtml += template;
      });
    }

    return variantsHtml;
  }

  /**
   * Build item properties, if available
   * @param  {Object} item The item
   * @param  {String} template The item template
   * @return {String}      The item properties HTML, if available, otherwise - ''
   */

  buildVariantProperties(item, template) {
    const hasProperties = item.properties != null && item.properties != {};
    let propertiesHtml = '';

    if (hasProperties) {
      Object.keys(item.properties).forEach((key) => {
        template = template.replace(/{{propertyKey}}/g, key);
        template = template.replace(
          /{{propertyKeyValue}}/g,
          item.properties[key].indexOf('/uploads/') != -1
            ? `<a href="${item.properties[key]}">${item.properties[key].split('/uploads/')[1]}</a>`
            : item.properties[key]
        );
        propertiesHtml += template;
      });
    }

    return propertiesHtml;
  }

  /**
   * Build cart page
   * @param  {Object} cart JSON of the cart
   * @return {void}
   */

  buildCartPage(cart) {
    const itemTemplate = Shopify.theme.templates.cart_item;
    const hasItems = cart.item_count;
    let template = Shopify.theme.templates.cart_items_holder;
    let templateEmpty = Shopify.theme.templates.cart_items_holder_empty;
    let itemsHtml = '';
    let html = '';
    let savings = '';

    this.updateCounter(hasItems);

    if (!hasItems) {
      html = templateEmpty;
    }

    if (hasItems) {
      cart.items.forEach((item, index) => {
        const hasVariants = item.options_with_values.length && item.options_with_values[0].value != 'Default Title';
        let html = itemTemplate;
        let variantsHtml = '';

        if (item.image != null) {
          html = html.replace(/{{itemImageUrl}}/g, this.optimizeImageUrl(item.image, '_280x'));
        } else {
          html = html.replace(
            /{{itemImageUrl}}/g,
            'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_280x.gif'
          );
        }

        if (hasVariants) {
          variantsHtml = Shopify.theme.templates.cart_item_variants;
          variantsHtml = variantsHtml.replace(/{{itemVariantTitle}}/g, item.title);
        }

        html = html.replace(/{{itemUrl}}/g, item.url);
        html = html.replace(/{{itemTitle}}/g, item.product_title);
        html = html.replace(/{{itemVariants}}/g, variantsHtml);
        html = html.replace(/{{itemProperties}}/g, this.buildVariantProperties(item, Shopify.theme.templates.cart_item_properties));
        html = html.replace(/{{itemIndex}}/g, index + 1);
        html = html.replace(/{{itemKey}}/g, item.key);
        html = html.replace(/{{itemPrice}}/g, Shopify.formatMoney(item.price, Shopify.current_money_format));
        html = html.replace(/{{itemLinePrice}}/g, Shopify.formatMoney(item.line_price, Shopify.current_money_format));
        html = html.replace(/{{itemId}}/g, item.id);
        html = html.replace(/{{itemQuantity}}/g, item.quantity);

        itemsHtml += html;
      });

      html = template;
      html = html.replace(/{{cartItems}}/g, itemsHtml);
      html = html.replace(/{{cartTotalPrice}}/g, Shopify.formatMoney(cart.total_price, Shopify.current_money_format));

      if (cart.total_discount > 0) {
        savings = Shopify.theme.locale.cart.general.savings_html.replace(
          /{{ price }}/g,
          Shopify.formatMoney(cart.total_discount, Shopify.current_money_format)
        );
      }

      html = html.replace(/{{cartSavings}}/g, savings);
    }

    $(this.selectors.cartHolder).empty();
    $(html).appendTo($(this.selectors.cartHolder));
  }

  /**
   * Build the cart items
   * @return {void}
   */

  build(cart, isCartPage) {
    if (isCartPage) {
      this.buildCartPage(cart);

      return;
    }

    const itemTemplate = Shopify.theme.templates.line_item;
    const hasItems = cart.item_count;
    let html = Shopify.theme.templates.cart_drawer;
    let itemsHtml = '';

    this.updateCounter(hasItems);

    if (!hasItems) {
      html = html.replace(/{{cartItems}}/g, `<p>${Shopify.theme.locale.cart_drawer.general.empty}</p>`);
      html = html.replace(/{{cartPrice}}/g, '');
    }

    if (hasItems) {
      cart.items.forEach((item) => {
        let html = itemTemplate;

        if (item.image != null) {
          html = html.replace(/{{lineItemImageUrl}}/g, this.optimizeImageUrl(item.image, '_200x'));
        } else {
          html = html.replace(
            /{{lineItemImageUrl}}/g,
            'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_200x.gif'
          );
        }

        html = html.replace(/{{lineItemUrl}}/g, item.url);
        html = html.replace(/{{lineItemTitle}}/g, item.product_title);
        html = html.replace(/{{lineItemVariants}}/g, this.buildVariantOptions(item));
        html = html.replace(/{{lineItemProperties}}/g, this.buildVariantProperties(item, Shopify.theme.templates.line_item_properties));
        html = html.replace(/{{lineItemPrice}}/g, Shopify.formatMoney(item.line_price, Shopify.current_money_format));
        html = html.replace(/{{lineItemId}}/g, item.key);
        html = html.replace(/{{lineItemQuantity}}/g, item.quantity);

        itemsHtml += html;
      });

      html = html.replace(/{{cartItems}}/g, itemsHtml);
      html = html.replace(/{{cartPrice}}/g, Shopify.formatMoney(cart.total_price, Shopify.current_money_format));
    }

    $(this.selectors.cartDrawer).empty();
    $(html).appendTo($(this.selectors.cartDrawer));

    $(this.selectors.cartDrawer).toggleClass(this.classes.empty, !hasItems);

    this.isCartBuilded = true;

    this.open();
  }

  /**
   * Opens the cart drawer
   * @return {void}
   */

  open() {
    if (this.isCartBuilded) {
      $(this.selectors.body).addClass(this.classes.bodyClass);
      $(this.selectors.cartDrawer).addClass(this.classes.visible);
    } else {
      this.getCart();
    }
  }

  /**
   * Closes the cart drawer
   * @return {void}
   */

  close() {
    $(this.selectors.body).removeClass(this.classes.bodyClass);
    $(this.selectors.cartDrawer).removeClass(this.classes.visible);
  }

  /**
   * Update cart items counters
   * @param  {Boolean} hasItems
   * @return {void}
   */

  updateCounter(hasItems) {
    $(this.classes.cartCount)
      .toggleClass(this.classes.hidden, !hasItems)
      .text(`(${hasItems})`);
  }

  /**
   * Optimize image based on parameter
   * @param  {String} url       Image url
   * @param  {String} parameter Size of the image, for example: '_200x'
   * @return {String}           Optimized image URL
   */

  optimizeImageUrl(url, parameter) {
    let imageUrl = url.split('.');
    imageUrl[2] = imageUrl[2] + parameter;
    imageUrl = imageUrl.join('.');

    return imageUrl;
  }
}

/**
 * Assign the Cart class to the window object for global use
 */

window.Cart = new Cart();
